import logoSvg from "./brand/logo.svg?raw";
import markSvg from "./brand/mark.svg?raw";
import markSmallSvg from "./brand/mark-small.svg?raw";

/**
 * bips brand files from design/brand/bips: the "On target" mark (two vault-bar segments split by the dashed
 * target line) and the outlined Inter Tight wordmark, currentColor. Colour comes from CSS `color`.
 */
export function Mark({
  size = 24,
  className,
  title = "bips",
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  // Below 28px the fine target line disappears, so use the small cut (wider gap, three heavy dashes).
  const svg = size < 28 ? markSmallSvg : markSvg;
  return (
    <span
      role="img"
      aria-label={title}
      className={className}
      style={{ display: "inline-block", width: size, height: size, lineHeight: 0 }}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: static, first-party SVG
      dangerouslySetInnerHTML={{ __html: svg.replace("<svg ", '<svg width="100%" height="100%" ') }}
    />
  );
}

/** Horizontal lockup. `height` is the rendered height in px; width follows the artwork. */
export function Logo({ height = 24, className }: { height?: number; className?: string }) {
  return (
    <span
      role="img"
      aria-label="bips"
      className={className}
      style={{ display: "inline-block", height, aspectRatio: "5571.83 / 1908", lineHeight: 0 }}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: static, first-party SVG
      dangerouslySetInnerHTML={{ __html: logoSvg.replace("<svg ", '<svg width="100%" height="100%" ') }}
    />
  );
}
